/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalReauthReportGenerationState } from './PalReauthReportGenerationState';
import {
    PalReauthReportGenerationStateFromJSON,
    PalReauthReportGenerationStateFromJSONTyped,
    PalReauthReportGenerationStateToJSON,
} from './PalReauthReportGenerationState';
import type { PalReauthReportGenerationTrigger } from './PalReauthReportGenerationTrigger';
import {
    PalReauthReportGenerationTriggerFromJSON,
    PalReauthReportGenerationTriggerFromJSONTyped,
    PalReauthReportGenerationTriggerToJSON,
} from './PalReauthReportGenerationTrigger';

/**
 * 
 * @export
 * @interface PalReauthReportGeneration
 */
export interface PalReauthReportGeneration {
    /**
     * 
     * @type {string}
     * @memberof PalReauthReportGeneration
     */
    id: string;
    /**
     * 
     * @type {PalReauthReportGenerationState}
     * @memberof PalReauthReportGeneration
     */
    state: PalReauthReportGenerationState;
    /**
     * 
     * @type {PalReauthReportGenerationTrigger}
     * @memberof PalReauthReportGeneration
     */
    trigger: PalReauthReportGenerationTrigger;
    /**
     * 
     * @type {string}
     * @memberof PalReauthReportGeneration
     */
    report_text?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PalReauthReportGeneration
     */
    overridden_report_text?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PalReauthReportGeneration
     */
    error_message?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof PalReauthReportGeneration
     */
    date_created: Date;
}

/**
 * Check if a given object implements the PalReauthReportGeneration interface.
 */
export function instanceOfPalReauthReportGeneration(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "trigger" in value;
    isInstance = isInstance && "date_created" in value;

    return isInstance;
}

export function PalReauthReportGenerationFromJSON(json: any): PalReauthReportGeneration {
    return PalReauthReportGenerationFromJSONTyped(json, false);
}

export function PalReauthReportGenerationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthReportGeneration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'state': PalReauthReportGenerationStateFromJSON(json['state']),
        'trigger': PalReauthReportGenerationTriggerFromJSON(json['trigger']),
        'report_text': !exists(json, 'report_text') ? undefined : json['report_text'],
        'overridden_report_text': !exists(json, 'overridden_report_text') ? undefined : json['overridden_report_text'],
        'error_message': !exists(json, 'error_message') ? undefined : json['error_message'],
        'date_created': (new Date(json['date_created'])),
    };
}

export function PalReauthReportGenerationToJSON(value?: PalReauthReportGeneration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'state': PalReauthReportGenerationStateToJSON(value.state),
        'trigger': PalReauthReportGenerationTriggerToJSON(value.trigger),
        'report_text': value.report_text,
        'overridden_report_text': value.overridden_report_text,
        'error_message': value.error_message,
        'date_created': (value.date_created.toISOString()),
    };
}

